







































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _findIndex from 'lodash/findIndex'
import _filter from 'lodash/filter'
import _sampleSize from 'lodash/sampleSize'
import _shuffle from 'lodash/shuffle'

import AssociationDetailOverlay from '@/components/overlays/AssociationDetailOverlay.vue'
import BaseAssociationPanel from '@/components/common/BaseAssociationPanel.vue'
import BaseImage from '@/components/common/BaseImage.vue'
import CreateAssociationOverlay from '@/components/overlays/CreateAssociationOverlay.vue'

import { scrollToTop } from '@/service/animations'
import { isMobile } from '@/service/utils'

import { IAssociation } from '@/models'

@Component( {
    components: {
        'oe-association-detail-overlay': AssociationDetailOverlay,
        'oe-base-image': BaseImage,
        'oe-base-association': BaseAssociationPanel,
        'oe-create-association-overlay': CreateAssociationOverlay
    },
    computed: mapGetters( {
        associations: 'associationsModule/associations',
        associationById: 'associationsModule/associationById',
        currentImage: 'imagesModule/currentImage',
        totalAssociations: 'associationsModule/totalAssociations'
    } )
} )
export default class ExplorerView extends Vue {
    $refs!: {
        createAssociationOverlay: CreateAssociationOverlay;
        associationDetailOverlay: AssociationDetailOverlay;
    }
    associationStatsVisible = false
    totalAssociationStatsVisible = false
    associations!: any
    associationById!: any
    currentImage!: any
    randomAssociations: Array<IAssociation> = []

    filteredAssociations() {
        const selectedAssociations = _shuffle( _sampleSize( _filter( this.associations, {
            language: this.$i18n.locale,
            relatedImage: this.currentImage.id
        } ), 6 ) )
        const userSelectedAssociation = this.$route.query.associationId

        if ( userSelectedAssociation ) {
            const associationIndex = _findIndex( selectedAssociations, { id: userSelectedAssociation } )

            if ( associationIndex !== -1 ) {
                const associationTemp1 = selectedAssociations[associationIndex]
                const associationTemp2 = selectedAssociations[0]

                selectedAssociations[0] = associationTemp1
                selectedAssociations[associationIndex] = associationTemp2
            } else {
                selectedAssociations[0] = this.associationById( userSelectedAssociation )
            }
        }

        return selectedAssociations
    }

    createAssociation( event: Event ) {
        event.preventDefault()

        this.$refs.createAssociationOverlay.showOverlay()
    }

    showAssociationDetail( id: string ) {
        this.$refs.associationDetailOverlay.showOverlay( id )
    }

    showAssociationStats() {
        this.associationStatsVisible = true
    }

    loadMoreAssociations() {
        this.associationStatsVisible = false
        this.totalAssociationStatsVisible = true
        this.randomAssociations = this.filteredAssociations()
        if ( isMobile() ) scrollToTop()
    }

    setAnotherImage() {
        this.associationStatsVisible = false
        this.$store.commit( 'imagesModule/setCurrentImage' )
        this.randomAssociations = this.filteredAssociations()
        if ( isMobile() ) scrollToTop()
    }

    @Watch( '$i18n.locale' )
    resetAssociations() {
        this.randomAssociations = this.filteredAssociations()
    }

    mounted() {
        this.randomAssociations = this.filteredAssociations()
        this.$store.commit( 'imagesModule/setCurrentImage', this.$route.query.imageId )
    }

    created(): void {
        this.$on( 'showAssociationDetail', this.showAssociationDetail )
    }
}
